<template>
  <div>
    <v-card :loading="dataLoading">
      <v-card-title> Add Language Skills </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <InfoBox title="Add Your Languages here! (Include your proficiency level)" />
          </v-col>
          <v-col cols="12">
            <v-btn class="primary_btn w-100" prepend-icon="mdi-plus" @click="showAddOrEdit = true">Add Language</v-btn>
          </v-col>
        </v-row>
        <LanguageSkillList
          :isHiringmanager="isHiringmanager"
          :isAfterSignUp="isAfterSignUp"
          @remove="remove"
          @edit="edit"
          :languageSkillList="items"
          :addLoading="addLoading"
        />
      </v-card-text>

      <v-dialog persistent v-model="showRemoveConfirm" @keydown.esc="showRemoveConfirm = false" max-width="400px">
        <confirm-dialog
          :loading="deleteLoading"
          @confirm="confirmDelete"
          @cancel="
            showRemoveConfirm = false;
            deleteLoading = false;
          "
          :message="confirmModel"
        >
        </confirm-dialog>
      </v-dialog>
    </v-card>
    <v-dialog v-if="showAddOrEdit" v-model="showAddOrEdit" max-width="1000" @keydown.esc="cancel()" persistent>
      <LanguageSkillRegister
        :isHiringmanager="isHiringmanager"
        :isGettingLanguages="isGettingLanguages"
        :isAfterSignUp="isAfterSignUp"
        :editingItem="editingItem"
        @saved="saveLanguageSkill"
        :addLoading="addLoading"
        @cancel="cancel"
      />
    </v-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import LanguageSkillRegister from "./LanguageSkillRegister.vue";
import LanguageSkillList from "./LanguageSkillList.vue";
import TeamMemberService from "../../../services/TeamMemberService";
import { Teammember, LanguageSkill } from "../../../models/Teammember";
import ConfirmDialog from "../../ConfirmDialog.vue";
import { ProjectMessages } from "../../../definitions/constants";
import InfoBox from "../../InfoBox.vue";
import store from "@/store";

export default defineComponent({
  props: ["isAfterSignUp", "formLoading", "isGettingAllSection", "languageSkills", "selectedTeammemberModel", "isHiringmanager"],
  components: {
    LanguageSkillRegister,
    ConfirmDialog,
    LanguageSkillList,
    InfoBox,
  },
  async mounted() {
    this.$emit("getLanguageSkills");
    this.items = this.languageSkills;
  },
  data() {
    return {
      isGettingLanguages: false,
      addLoading: false,
      dataLoading: false,
      technologies: [] as string[],
      selectedItem: {} as LanguageSkill,
      editingItem: null as LanguageSkill | null,
      itemRemoveId: -1,
      showRemoveConfirm: false,
      teammember: {} as Teammember | null,
      selectedId: null as string | null,
      loading: false,
      deleteLoading: false,
      showDialog: false,
      items: [] as LanguageSkill[] | null,
      confirmModel: {
        title: ProjectMessages.removeLanguage,
        text: ProjectMessages.confirmation,
      },
      showAddOrEdit: false,
    };
  },
  methods: {
    cancel(): void {
      this.editingItem = null;
      this.showAddOrEdit = false;
    },
    remove(item: LanguageSkill): void {
      this.selectedItem = item;
      this.showRemoveConfirm = true;
    },
    async confirmDelete() {
      this.deleteLoading = true;
      if (this.selectedItem) {
        var result = await TeamMemberService.deleteLanguageSkill(
          this.selectedItem.Id,
          this.selectedTeammemberModel ? this.selectedTeammemberModel.id : ""
        );
        if (result) {
          this.$emit("setLanguagesState", result);
          this.editingItem = null;
          this.items = result;
          store.dispatch("showSuccessMessage", ProjectMessages.succesfullyDeleteLanguageSkill);
        }
      }
      this.showRemoveConfirm = false;
      this.deleteLoading = false;
    },
    edit(item: any): void {
      this.editingItem = item;
      this.showAddOrEdit = true;
    },
    async saveLanguageSkill(event: { model: LanguageSkill; callbackMethod: any }): Promise<void> {
      if (event.model && event.model.Language && event.model.Level) {
        this.addLoading = true;
        try {
          var result = await TeamMemberService.setLanguageSkill(event.model, this.selectedTeammemberModel ? this.selectedTeammemberModel.id : "");
          if (result && result.length > 0) {
            this.$emit("setLanguagesState", result);
            this.editingItem = null;
            this.items = result;
            this.$emit("fillLanguages", result);
            if (!this.isGettingLanguages) {
              if (event.model.Id) {
                store.dispatch("showSuccessMessage", ProjectMessages.succesfullyUpdateLanguageSkill);
              } else {
                store.dispatch("showSuccessMessage", ProjectMessages.succesfullyAddLanguageSkill);
              }
            }
            event.callbackMethod();
          } else {
            if (!this.isGettingLanguages) {
              store.dispatch("showErrorMessage", "Couldn't save language!");
            }
          }
        } finally {
          this.addLoading = false;
        }
      } else if (this.isGettingLanguages) {
        this.$emit("fillLanguages");
      }
    },
  },
  watch: {
    formLoading(newVal) {
      this.dataLoading = newVal;
    },
    languageSkills(newVal) {
      this.items = newVal;
    },
    isGettingAllSection(newVal) {
      this.isGettingLanguages = newVal;
    },
  },
});
</script>
